import React, {useState, useEffect, useRef} from 'react';
import { useDelayedTickContext } from "../../context/DelayedTickContext";
import {useStateUpdatePermission} from "../../../contexts/StateUpdateContext";
import {useQuoteContext} from "../../../contexts/QuoteContext";
import {formatIndianValue} from "@portfolio/utils/formatNumber";
import {useSharingContext} from "@dashboard/contexts/SharingContext";

const OverAllGainDisplay = ({ instrumentToken,stock, overAllGainColor,setOverAllGainColor, contextName,shouldUseStockForDisplay  }) => {
    /*const [overallGain, setOverallGain] = useState(null);
    const [overallGainPercentage, setOverallGainPercentage] = useState(null);*/
    const overallGainRef = useRef(null);
    const overallGainPercentageRef = useRef(null);
    const { canUpdateState } = useStateUpdatePermission(); // Access the permission state
    const delayedTickContext = useDelayedTickContext();
    const quoteContext = useQuoteContext();
    const { showFormattedNumbers } = useSharingContext();

    const contextData = (() => {
        switch (contextName) {
            case 'DelayedTickContext':
                return delayedTickContext;
            case 'QuoteContext':
                return quoteContext;
            default:
                throw new Error(`Unknown context: ${contextName}`);
        }
    })();
    const delayedTick = contextData.delayedTick;

    useEffect(() => {
        if (canUpdateState) {
            const newOverallGain = stock.overallGain.toFixed(2);
            const newOverallGainPercentage = stock.overallGainPercentage.toFixed(2);

            if (overallGainRef.current !== newOverallGain) {
                overallGainRef.current = newOverallGain;
            }
            if (overallGainPercentageRef.current !== newOverallGainPercentage) {
                overallGainPercentageRef.current = newOverallGainPercentage;
            }

            if (stock.overallGain>0) {
                setOverAllGainColor('#33A533'); // Set green for upward trend
            } else {
                setOverAllGainColor('#FF6666'); // Set red for downward trend
            }
        }
    }, []);

    // Fetch and calculate price difference
    useEffect(() => {
        if (canUpdateState) {
            if (delayedTick.lastTradedPrice && delayedTick.closePrice) {
                const newOverallGain = ((delayedTick.lastTradedPrice - stock.weightedAvgPrice)*stock.netQuantity).toFixed(2);
                const newOverallGainPercentage = ((newOverallGain/ stock.amountInvested ) * 100).toFixed(2);

                if (overallGainRef.current !== newOverallGain) {
                    overallGainRef.current = newOverallGain;
                }
                if (overallGainPercentageRef.current !== newOverallGainPercentage) {
                    overallGainPercentageRef.current = newOverallGainPercentage;
                }

                if (overallGainRef.current>0) {
                    setOverAllGainColor('#33A533'); // Set green for upward trend
                } else {
                    setOverAllGainColor('#FF6666'); // Set red for downward trend
                }
            }
        }
    }, [delayedTick.lastTradedPrice]);

    return (
        <div className="overallgain-display" >
             <div className="overall-gain-percentage" style={{color: overAllGainColor}}>
                {shouldUseStockForDisplay ? (
                    <>
                        {stock.overallGainPercentage < 0 && <span className="negative">-</span>}
                        {Math.abs(stock.overallGainPercentage ?? 0).toFixed(2)}%
                    </>
                ) : (
                    <>
                        {overallGainPercentageRef.current < 0 && <span className="negative">-</span>}
                        {Math.abs(overallGainPercentageRef.current ?? 0)}%
                    </>
                )}
            </div>
            <span className="overall-gain-amount">
               {formatIndianValue(
                   shouldUseStockForDisplay
                        ? stock.overallGain
                        : overallGainRef.current ?? stock.overallGain,
                   showFormattedNumbers
                )}
            </span>
        </div>
    );
};


export default OverAllGainDisplay;
